import React, { useEffect } from "react";
import classes from "./GoBackHeader.module.css";

//libraries
import { Link } from "react-router-dom";

//icons
import logo from "../../images/logoHD.png";
import back from "../../images/back.png";

//this component displays the Header in pages other than the main to head back to the main page
const GoBackHeader = (props) => {
  useEffect(() => {
    if (props.transparent) {
      const cont = document.getElementsByClassName(classes.container)[0];
      cont.style.backgroundColor = "#ffffff48"
    }
  }, [props.transparent]);

  return (
    <div className={classes.container}>
      <Link to="..">
        <div className={classes.goBack}>
          <img src={back} alt={"back"} />
          Go Back Home
        </div>
      </Link>
      <div className={classes.logo}>
        <Link to="..">
          <img src={logo} alt={"logo"} />
        </Link>
      </div>
      <div className={classes.bigTitle}>TURNING DISABILITY INTO ABILITY</div>
    </div>
  );
};
export default GoBackHeader;
